
export const arrayDeepEqual = (a:unknown, b:unknown):boolean => Array.isArray(a)
    && Array.isArray(b)
    && a.length === b.length
    && a.every((val, index) => {
      if (typeof val === 'object') {
        return Array.isArray(val) ? arrayDeepEqual(a[index], b[index]) : shallowEqual(a[index], b[index]);
      }
      return val === b[index];
    });

export const shallowEqual = <T extends Record<string, unknown>>(object1:T, object2:T) => {
  const keys1 = Object.keys(object1 ?? {});
  const keys2 = Object.keys(object2 ?? {});

  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const field of keys1) {
    let areDifferent = false;
    if (typeof object1[field] === 'object') {
      const fn = Array.isArray(object1[field]) ? arrayDeepEqual : shallowEqual;
      areDifferent = fn(object2[field] as any, object1[field] as any);
    } else {
      areDifferent = object1[field] !== object2[field];
      if (areDifferent) {
        return false;
      }
    }
  }
  return true;
};

export function createDictionary<U extends string, T>(dictionary: Partial<Record<U, T>>, defaultValue: T) {
  return new Proxy(dictionary, {
    get: (target, name: U) => (name in target ? target[name] : defaultValue),
  });
}

export function uniq<T>(array: T[]) {
  return Array.from(new Set(array));
}
